import { motion } from "framer-motion";
import { Factory, Warehouse, Ruler, Truck, BadgeCheck } from "lucide-react";
import { useLanguage } from "@/i18n";

const icons = [Factory, Warehouse, Ruler, Truck, BadgeCheck];

export default function Advantages() {
  const { t } = useLanguage();
  return (
    <section id="keunggulan" className="py-24 sm:py-32 bg-[#0B1220]" data-testid="advantages-section">
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1] }}
          className="max-w-2xl"
        >
          <p className="font-mono text-xs tracking-[0.25em] uppercase text-sky-400 font-semibold">{t.advantages.eyebrow}</p>
          <h2 className="mt-4 font-display font-extrabold tracking-tight text-white text-2xl sm:text-3xl lg:text-4xl">{t.advantages.title}</h2>
          <p className="mt-4 text-slate-400 text-base sm:text-lg">{t.advantages.sub}</p>
        </motion.div>

        <div className="mt-14 grid md:grid-cols-3 gap-5 auto-rows-fr">
          {t.advantages.items.map((item, i) => {
            const Icon = icons[i];
            return (
              <motion.div
                key={i}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-60px" }}
                transition={{ duration: 0.7, delay: i * 0.08, ease: [0.16, 1, 0.3, 1] }}
                data-testid={`advantage-card-${i + 1}`}
                className={`group rounded-2xl border p-8 flex flex-col justify-between gap-8 transition-all duration-500 hover:-translate-y-1.5 hover:shadow-[0_24px_50px_-20px_rgba(0,0,0,0.6)] ${
                  item.big
                    ? "md:col-span-2 bg-sky-500 border-sky-400"
                    : "bg-[#101B2E] border-slate-800 hover:border-sky-500/60"
                }`}
              >
                <div className={`w-12 h-12 rounded-xl flex items-center justify-center transition-transform duration-500 group-hover:scale-110 group-hover:-rotate-6 ${
                  item.big ? "bg-white/20 text-white" : "bg-[#0B1220] text-sky-400 border border-slate-700"
                }`}>
                  <Icon size={22} />
                </div>
                <div>
                  <h3 className={`font-display font-bold text-lg sm:text-xl ${item.big ? "text-white" : "text-slate-100"}`}>{item.title}</h3>
                  <p className={`mt-2 text-sm sm:text-base leading-relaxed ${item.big ? "text-sky-50" : "text-slate-400"}`}>{item.desc}</p>
                </div>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
